export default __webpack_public_path__ + "static/media/main click pass.76a8544a.png";